import React from "react";
import { Field, ErrorMessage, useFormikContext } from "formik";
import { Icon } from "@iconify/react";
import { getDepartmentsForContext } from "../../core/constants/departments";
import { useDepartments } from "../../core/DepartmentsContext";

const CHECKBOX_ICONS = {
  empty: "mdi:checkbox-blank-outline",
  checked: "mdi:checkbox-marked-outline",
};

const RADIO_ICONS = {
  empty: "material-symbols:circle-outline",
  checked: "material-symbols:circle",
};

/**
 * Checkbox group for department selection in registration/profile forms.
 * Options come from the departments API; form values are department ObjectIds.
 */
const DepartmentCheckboxGroup = ({
  name = "departments",
  context = "registration",
  showError = true,
  maxSelections,
}) => {
  const { departments: catalog } = useDepartments();
  const departments = getDepartmentsForContext(context, catalog);
  const { values, setFieldValue } = useFormikContext();
  const selected = values[name] || [];
  const singleSelect = maxSelections === 1;

  return (
    <div>
      {departments.map((dept) => {
        const value = dept._id ? String(dept._id) : dept.name;
        const id = `dept-${dept.name.replace(/[^a-z0-9]/gi, "").toLowerCase()}`;
        const isSelected = singleSelect
          ? selected[0] === value
          : selected.includes(value);
        const icons = singleSelect ? RADIO_ICONS : CHECKBOX_ICONS;

        if (singleSelect) {
          return (
            <div className="radio-select" key={value}>
              <input
                type="radio"
                id={id}
                name={name}
                value={value}
                checked={isSelected}
                onChange={() => setFieldValue(name, [value])}
              />
              <label htmlFor={id}>
                <Icon
                  icon={icons.empty}
                  width="1.5rem"
                  height="1.5rem"
                  className="radio-icon radio-empty"
                />
                <Icon
                  icon={icons.checked}
                  width="1.5rem"
                  height="1.5rem"
                  className="radio-icon radio-full"
                />
                {dept.name}
              </label>
            </div>
          );
        }

        return (
          <div className="radio-select" key={value}>
            <Field type="checkbox" id={id} name={name} value={value} />
            <label htmlFor={id}>
              <Icon
                icon={icons.empty}
                width="1.5rem"
                height="1.5rem"
                className="radio-icon radio-empty"
              />
              <Icon
                icon={icons.checked}
                width="1.5rem"
                height="1.5rem"
                className="radio-icon radio-full"
              />
              {dept.name}
            </label>
          </div>
        );
      })}
      {showError && (
        <ErrorMessage
          name={name}
          component="div"
          style={{ color: "#CD3E3D" }}
        />
      )}
    </div>
  );
};

export default DepartmentCheckboxGroup;
